import {useState} from "react";

import DefaultLogo from "@/assets/images/integrations/default.png";
import Button from "@/components/button/Button.tsx";
import {Card} from "@/components/card/Card.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {StatusPill} from "@/components/statusPill/StatusPill.tsx";
import {PillStatus} from "@/components/statusPill/StatusPill.types.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {EditIntegrationModalAction} from "@/pages/integrations/edit/EditIntegrationModalAction.tsx";
import {
  generateBlankIntegrationFormData,
  IntegrationModuleInfo,
  IntegrationModules,
} from "@/pages/integrations/integrations.types.ts";

interface IntegrationCardProps {
  module: IntegrationModules;
  isActive: boolean;
  setNewIntegration?: (newIntegration: IntegrationFormData) => void;
}

export const IntegrationCard = ({module, isActive = false, setNewIntegration}: IntegrationCardProps) => {
  const {user} = useCurrentUserContext();
  const [showEdit, setShowEdit] = useState(false);
  const moduleInfo = IntegrationModuleInfo[module];

  return (
    <div>
      <Card variant="integration" className={"d-flex flex-row align-items-center justify-content-between gap-3"}>
        <div className={"d-flex flex-row align-items-center gap-3"}>
          <img
            src={moduleInfo.logo ?? DefaultLogo}
            alt={moduleInfo.label}
            height={36}
            width={36}
            className={"pulse-border-radius-xl"}
          />
          <div className={"d-flex flex-column gap-1"}>
            <div className={"pulseTextBodyBold d-flex align-items-center"}>
              <span>{moduleInfo.label}</span>
              {isActive && (
                <span className={"ps-2"}>
                  <StatusPill variant={"textAndIcon"} status={PillStatus.ACTIVE_INTEGRATION} type={"checks"} />
                </span>
              )}
            </div>
            <div className={"pulseTextBodySmall pulse-color-gray-700 pe-2"}>{moduleInfo.description}</div>
          </div>
        </div>
        <div>
          {user?.has_write_access && (
            <Button variant={"secondary"} size={"extraSmall"} onClick={() => setShowEdit(true)}>
              Add
            </Button>
          )}

          {showEdit && (
            <EditIntegrationModalAction
              formId={`form-new-integration`}
              show={showEdit}
              setShow={setShowEdit}
              integration={generateBlankIntegrationFormData(module)}
              setNewIntegration={setNewIntegration}
            />
          )}
        </div>
      </Card>
    </div>
  );
};
